import LogoutIcon from '@mui/icons-material/Logout';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import {
  Avatar,
  Box,
  Button,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import type { MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '@/features/auth/hooks/useAuth';
import { AUTH_ROUTES } from '@/features/auth/routes';

const ROL_LABELS: Record<string, string> = {
  administrador: 'Administrador',
  tecnico_laboratorio: 'Técnico de laboratorio',
  profesional: 'Profesional',
  establecimiento: 'Establecimiento',
};

export function UserMenu(): JSX.Element | null {
  const navigate = useNavigate();
  const { currentUser, signOut } = useAuth();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  if (!currentUser) return null;

  function handleOpen(e: MouseEvent<HTMLElement>): void {
    setAnchorEl(e.currentTarget);
  }
  function handleClose(): void {
    setAnchorEl(null);
  }
  function handleChangePassword(): void {
    handleClose();
    navigate(AUTH_ROUTES.CHANGE_PASSWORD);
  }
  async function handleSignOut(): Promise<void> {
    handleClose();
    await signOut();
  }

  const displayName = currentUser.nombre ?? currentUser.username;
  const initials = displayName
    .split(' ')
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <>
      <Button
        onClick={handleOpen}
        sx={{
          textTransform: 'none',
          gap: 1.5,
          px: 1.5,
          color: 'text.primary',
        }}
        aria-controls="user-menu"
        aria-haspopup="true"
      >
        <Box sx={{ textAlign: 'right', display: { xs: 'none', sm: 'block' } }}>
          <Typography variant="body2" sx={{ lineHeight: 1.2, fontWeight: 600 }}>
            {displayName}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {ROL_LABELS[currentUser.rol] ?? currentUser.rol}
          </Typography>
        </Box>
        <Avatar
          sx={{
            bgcolor: 'primary.main',
            width: 36,
            height: 36,
            fontSize: '0.95rem',
          }}
        >
          {initials}
        </Avatar>
      </Button>

      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={handleChangePassword}>
          <ListItemIcon>
            <VpnKeyIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Cambiar contraseña</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => void handleSignOut()}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Cerrar sesión</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
